import Icon from "~/components/ui/Icon"
import { ImageWidget } from "~/types/widgets"
import Image from "~/components/ui/Image"

/**
 * @titleBy label
 */
export interface PaymentItem {
    label: string
    /**
     * @title Imagem
     * @description Isso deverá ser mudado para SVG no futuro
     */
    image: ImageWidget
}

/**
 * @title Métodos de Pagamento
 */
export interface Props {
    /**
     * @title Título
     */
    title: string
    /**
     * @title Métodos
     */
    methods: PaymentItem[]
    /**
     * @title Itens por linha
     * @description Defina a quantidade de itens que ficará em cada linha
     * @default 3
     */
    itemsPerRow?: number
    /**
     * @ignore
     */
    isMobile?: boolean
}

export default function PaymentMethods({ title, methods, itemsPerRow = 3, isMobile }: Props) {
    if (isMobile) {
        return (
            <div className='w-full'>
                <div className='collapse rounded-none text-sm relative'>
                    <input type='checkbox' id={`input-${title}`} className='fixed hidden peer' />
                    <label
                        htmlFor={`input-${title}`}
                        className='group collapse-title font-bold text-salmon-light p-0 min-h-0 h-12 w-full flex justify-between items-center text-base'
                    >
                        <span>{title}</span>
                        <Icon
                            id='ChevronRight'
                            size={24}
                            strokeWidth={2}
                            className='peer-checked:group-[]:rotate-90 absolute right-3 top-1/2 -translate-y-1/2 transition-transform'
                        />
                    </label>
                    <div className='collapse-content !p-0'>
                        <div className='pt-2 pb-4 px-0 w-fit'>
                            <ul
                                style={{
                                    gridTemplateColumns: `repeat(${itemsPerRow}, minmax(0, 1fr))`,
                                }}
                                className='grid gap-1 justify-center items-center w-fit'
                            >
                                {methods.map(({ label, image }) => (
                                    <li key={label ?? image} title={label}>
                                        <Image
                                            width={42}
                                            height={27}
                                            src={image}
                                            alt={label}
                                            loading='lazy'
                                        />
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='flex flex-col gap-4'>
            <p className='text-salmon-light font-bold'>{title}</p>
            <ul
                style={{
                    gridTemplateColumns: `repeat(${itemsPerRow}, minmax(0, 1fr))`,
                }}
                className='grid gap-1 justify-center items-center w-fit'
            >
                {methods.map(({ label, image }) => (
                    <li key={label ?? image} title={label}>
                        <Image width={42} height={27} src={image} alt={label} loading='lazy' />
                    </li>
                ))}
            </ul>
        </div>
    )
}
